import { motion } from "framer-motion";

export default function RevealText({ text, className = "", delay = 0, stagger = 0.08 }) {
  const lines = Array.isArray(text) ? text : [text];
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="reveal-mask block">
          <motion.span
            initial={{ y: "110%", rotate: 4 }}
            animate={{ y: "0%", rotate: 0 }}
            transition={{
              duration: 0.9,
              delay: delay + i * stagger,
              ease: [0.22, 1, 0.36, 1],
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

export function RevealTextOnView({ text, className = "", delay = 0, stagger = 0.08 }) {
  const lines = Array.isArray(text) ? text : [text];
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="reveal-mask block">
          <motion.span
            initial={{ y: "110%" }}
            whileInView={{ y: "0%" }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{
              duration: 0.85,
              delay: delay + i * stagger,
              ease: [0.22, 1, 0.36, 1],
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}
